import { useEffect, useState } from "react";
import { brand } from "../config/brand";
import {
  availableOrganizations,
  getOrganization,
  organizationOf,
  setOrganization,
  subscribe,
} from "../utils/organizationScope";

/* Both halves together: the available list can change while the id stays the
   same (a user losing the organization they are not on), and the switch has
   to re-render for that too. */
const snapshot = () => ({
  id: getOrganization(),
  available: availableOrganizations(),
});

/**
 * The selected organization, live: re-renders on a switch in this tab or
 * another, and when the user's permitted organizations arrive or change.
 *
 * `organizations` is the configured list - what the app is, and what a screen
 * that names the organization checks for "more than one". `available` is the
 * ones this user may use, which is what the switch and the chooser offer.
 * `select(id)` stores a new choice.
 */
export function useOrganization() {
  const [{ id, available }, setState] = useState(snapshot);

  useEffect(() => subscribe(() => setState(snapshot())), []);

  return {
    id,
    organization: organizationOf(id),
    organizations: brand.organizations,
    available,
    select: setOrganization,
  };
}
